<template>
  <div class="relative h-full w-full" style="padding-bottom: 10rem">

    <l-map ref="map" @ready="onReady()" class="h-full w-full z-0" :zoom="zoom" :maxZoom="maxZoom" :center="center"
      :options="{ zoomControl: true, tap:false }">
      <l-tile-layer :url="urlBasemap" :attribution="attribution"></l-tile-layer>
    </l-map>
    <div class="flex flex-col absolute top-0 left-0 mt-5 ml-5" style="margin-left: 60px">
      <div class="flex w-full" data-v-step="selectMunicipio">
        <v-select class="selectMun" :value="$store.myValue" :options="municipios" label="nombre"
          placeholder="Buscar un municipio o localidad" @input="setSelectedMun">
          <div slot="no-options">No hay coincidencias</div>
        </v-select>
      </div>
    </div>

    <buttons style="margin-top: 65px" @click="imgmap" @showPointSelector="showPointSelector"></buttons>

    <div class="absolute right-0 top-0 z-10 mr-5" v-if="showHelpUser">
      <div class="mt-4 text-2xl font-medium tracking-widest">
        <span class="bg-primary-color px-40 py-2 text-white">Seleccione una ubicación en el mapa o
        </span>
        <br>
        <div class="flex">
          <button @click="showHelpModal"
            class="flex-shrink-0 z-10 bg-primary-blue-700 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 dark:border-gray-700 dark:text-white rounded-l-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-300 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12 19.5C16.1421 19.5 19.5 16.1421 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5C7.85786 4.5 4.5 7.85786 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12.75 15V16.5H11.25V15H12.75ZM10.5 10.4318C10.5 9.66263 11.1497 9 12 9C12.8503 9 13.5 9.66263 13.5 10.4318C13.5 10.739 13.3151 11.1031 12.9076 11.5159C12.5126 11.9161 12.0104 12.2593 11.5928 12.5292L11.25 12.7509V14.25H12.75V13.5623C13.1312 13.303 13.5828 12.9671 13.9752 12.5696C14.4818 12.0564 15 11.3296 15 10.4318C15 8.79103 13.6349 7.5 12 7.5C10.3651 7.5 9 8.79103 9 10.4318H10.5Z"
                fill="#080341" />
            </svg>
          </button>
          <div class="relative w-full">
            <input type="text" placeholder="Pegue una url de google o coordenadas" @input="ValidateLink($event)"
              v-model="googleLink"
              class="block p-2 w-full z-20 text-sm bg-gray-50 rounded-r-lg border-l-gray-100 border-l-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500">
            <button @click="clearInput()"
              class="absolute top-0 right-0 p-3 h-full text-sm font-medium text-white bg-red-700 rounded-r-lg border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-blue-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                  fill="#0F1729" />
              </svg>
            </button>
          </div>
        </div>

        <span v-if="this.errorLink">Link no válido</span>
      </div>
    </div>

    <levantamiento-modal :showing="showLevantamientoModal" :latitud="coordsMarker[0]" :longitud="coordsMarker[1]"
      @close="closeLevantamientoModal()"></levantamiento-modal>

    <help-modal class="w-full" :showing="showHelpCoordsModal" @close="closeHelpModal()"></help-modal>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet.heat";
import "leaflet-geometryutil";
import EventBus from "../event-bus";
import buttons from "./Buttons";

import LevantamientoModal from "./LevantamientoModal";
import HelpModal from "./HelpModal.vue";
import { shortestPath } from "@turf/turf";

export default {
  name: "Map",
  data: function () {
    return {
      zoom: 9,
      maxZoom: 18,
      center: [20.58651, -89.01501],
      map: null,
      valor: { selectmap: "traffic" },
      coordsMarker: [0, 0],
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      googleLink: "",
      errorLink: false,
      showHelpUser: false,
      showLevantamientoModal: false,
      showHelpCoordsModal: false,
      markerLayer: null,
      urlMarker: null,
      drawMarker: null,
      isDrawing: false,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

      selectedMun: "",
      municipios: [],
      books: [
        { title: "Old Man's War" },
        { title: "The Lock Artist" },
        { title: "HTML5" },
        { title: "Right Ho Jeeves" },
        { title: "The Code of the Wooster" },
        { title: "Thank You Jeeves" }
      ]
    };
  },
  components: {
    LMap,
    LTileLayer,
    buttons,
    LevantamientoModal,
    HelpModal
  },
  watch: {
    "valor.selectmap": function (val) {
      if (val === "traffic") {
        this.urlBasemap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        this.urlBasemap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    }
  },

  methods: {
    onReady() {
      this.map = this.$refs.map.mapObject;
      this.markerLayer = new window.L.FeatureGroup().addTo(this.map);

      const drawControl = new window.L.Control.Draw({
        position: "topright",
        draw: {
          polyline: false,
          polygon: false,
          rectangle: false,
          circle: false,
          marker: false,
          circlemarker: false
        }
      });

      this.map.on("draw:created", e => {
        let layer = e.layer;
        console.log({ layer })
        layer.addTo(this.markerLayer);

        if (e.layerType == "marker") {
          this.coordsMarker = Array.from([
            layer._latlng.lat,
            layer._latlng.lng
          ]);

          layer.on("dragend", function (event) {
            this.coordsMarker = Array.from([
              layer._latlng.lat,
              layer._latlng.lng
            ]);
          });
        }

        this.showHelpUser = false;
        this.showLevantamientoModal = true;
        this.isDrawing = false;
      });

      this.controlAdd = drawControl;
      this.drawMarker = new L.Draw.Marker(this.map, this.controlAdd.options.marker);

    },
    imgmap: function (click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },

    clearInput: function (click) {
      this.googleLink = "";
      this.errorLink = false;
    },

    showPointSelector() {
      if (!this.isDrawing) {
        this.showHelpUser = true;
        this.drawMarker.enable();
        this.isDrawing = true;
      }
    },
    closeLevantamientoModal() {
      this.markerLayer.clearLayers();
      this.showLevantamientoModal = false;
      if(this.urlMarker){
        this.map.removeLayer(this.urlMarker)
      }
      this.map.panTo(this.center)
      this.map.setZoom(9);
      this.errorLink = false;
    },
    closeHelpModal() {
      this.showHelpCoordsModal = false;
    },
    fetchMunicipios() {
      console.log("fetchMunicipios");
      this.axios
        .get("apidev/miapptsil/getMunicipios", this.config)
        .then(response => {
          console.log(response["data"]["municipios"]);
          this.municipios = response["data"]["municipios"];
          /*           this.places = response.data;

          if (
            Object.keys(this.currentPlace).length === 0 &&
            this.currentPlace.constructor === Object
          ) {
            this.currentPlace = this.filteredPlaces[0];
          }
          this.center = [this.currentPlace.lat, this.currentPlace.lng];
          this.showMarker = true;
          this.fetchPlaceComments(this.currentPlace.id); */
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    setSelectedMun(value) {
      console.log("selected mun:", value);
      //console.log("selected mun:", this.selectedMun)
      let geojson = JSON.parse(value["geojson"]);
      console.log(geojson);

      let boundingBoxGeojson = L.geoJSON(geojson);
      let boundingBox = boundingBoxGeojson.getBounds();
      this.$refs.map.mapObject.fitBounds(boundingBox);
    },
    ValidateLink(e) {
      let link = e.target.value;
      if (link === "") {
        this.errorLink = false;
      } else {
        let urlreg1 = /([a-zA-Z]{3}\.)?google\.com(\.\w*)?/;
        let urlreg2 = /([a-zA-Z]{3}\.)?maps.app.goo.gl(\.\w*)?/;
        if (urlreg1.test(link)) {
          this.isDrawing = false;
          this.drawMarker.disable();
          const longUrlPattern = /3d([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?!4d([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?/gm;
          const middleUrlPattern = /(-?\d+\.\d+)+,+(-?\d+\.\d+)/gm
          if (longUrlPattern.test(link) && middleUrlPattern.test(link)) {
            console.log("link largo")
            let match = link.match(longUrlPattern)
            let coords = match[0].replace("3d", "").split("!4d")
            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);
            this.urlMarker.addTo(this.markerLayer);
          } else if (!longUrlPattern.test(link) && middleUrlPattern.test(link)) {
            console.log("link mediano", link);
            let match = link.match(middleUrlPattern)
            let coords = match[0].split(",")
            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);
            this.urlMarker.addTo(this.markerLayer);
          }
          this.googleLink = "";
          this.showHelpUser = false;
          this.showLevantamientoModal = true;
        } else if (urlreg2.test(link)) {
          console.log("link corto")
          this.axios.post("apidev/levantamientos/ValidateLink", {
            "link": link,
          },
            this.config
          )
            .then(response => {
              this.isDrawing = false;
              this.drawMarker.disable();
              this.coordsMarker = Array.from([
                parseFloat(response.data.lat),
                parseFloat(response.data.lng)
              ]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
              this.urlMarker = new L.Marker([parseFloat(response.data.lat),
              parseFloat(response.data.lng)]);
              this.urlMarker.addTo(this.markerLayer);
              this.googleLink = "";
              this.showHelpUser = false;
              this.showLevantamientoModal = true;
            })
            .catch(error => {
              console.log({ error })
            });
        } else if (link.includes(",")) {
          const coordsPattern = /([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?,([+-]?(?=\.\d|\d)(?:\d+)?(?:\.?\d*))(?:[Ee]([+-]?\d+))?/gm
          if (coordsPattern.test(link.replace(' ', ''))) {
            this.isDrawing = false;
            this.drawMarker.disable();
            console.log("Coordenadas", link);
            let coords = link.split(",")

            this.coordsMarker = Array.from([
              parseFloat(coords[0]),
              parseFloat(coords[1])
            ]);
            this.urlMarker = new L.Marker([parseFloat(coords[0]),
            parseFloat(coords[1])]);

            this.map.setZoom(20);
            this.map.panInside([parseFloat(coords[0]),parseFloat(coords[1])], {padding: [300, 500]})
            this.urlMarker.addTo(this.markerLayer);
            this.googleLink = "";
            this.showHelpUser = false;
            this.showLevantamientoModal = true;
          } else {
            console.log("link no válido")
            this.errorLink = true;
          }

        } else {
          console.log("link no válido")
          this.errorLink = true;
        }
      }
    },
    showHelpModal() {
      this.showHelpCoordsModal = true;
    }
  },



  changeSetting: function (index) {
    data.settingsSelected = data.settings[index];
  },
  created() { },
  mounted() {
    //this.getComplaints();
    this.fetchMunicipios();
  },
  activated() {
    EventBus.$emit("updateNotification", {});
  },
  computed: {
    options() {
      return {
        pointToLayer: function (feature, latlng) {
          let color = "";
          let fillColor = "";

          switch (feature.properties.status) {
            case "no atendida":
              color = "#000";
              fillColor = "#cb2833";
              break;
            case "en proceso":
              color = "#000";
              fillColor = "#ffc200";
              break;
            case "Cerradas":
            case "atendida":
              color = "#000";
              fillColor = "#898d8d";
              break;
            default:
              color = "#000";
              fillColor = "#cb2833";
              break;
          }

          return L.circleMarker(latlng, {
            radius: 8,
            fillColor: fillColor,
            color: color,
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8
          });
        }
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}

.leaflet-marker-iconlabel {
  background: #fff;
  border-radius: 7px;
  -moz-box-shadow: 0 3px 10px #888;
  -webkit-box-shadow: 0 3px 14px #999;
  box-shadow: 0 3px 10px #888;
  display: block;
  font: 11px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 4px 6px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
}

.text-help-user {
  left: 50%;
  transform: translateX(-50%);
}
</style>
